import { styled, css } from '@vebox/etui-system';
import { Component, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Button } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import { lighten, darken } from '@vebox/etui-colors';

const _excluded = ["type", "theme"];
const AlertDiv = styled(Div).attrs(_ref => {
  let {
      type,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    minHeight: '50px',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSizeBase,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: theme.typography.lineHeightBase,
    p: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
    mb: `${theme.spacing.md}px`,
    color: `${theme.palette.text.primary}`,
    borderRadius: `${theme.shape.borderRadius}px`
  }, props);
})`
  ${({
  type,
  theme
}) => {
  if (type === 'success') {
    return css`
        background-color: ${lighten(theme.palette.success.main, 0.9)};
        border: 1px solid ${theme.palette.success.main};
      `;
  }
  if (type === 'info') {
    return css`
        background-color: ${lighten(theme.palette.info.main, 0.9)};
        border: 1px solid ${theme.palette.info.main};
      `;
  }
  if (type === 'warning') {
    return css`
        background-color: ${lighten(theme.palette.warning.main, 0.9)};
        border: 1px solid ${theme.palette.warning.main};
      `;
  }
  if (type === 'error') {
    return css`
        background-color: ${lighten(theme.palette.error.main, 0.9)};
        border: 1px solid ${theme.palette.error.main};
      `;
  }
  return css`
      background-color: ${lighten(theme.palette.grey[80], 0.9)};
      border: 1px solid ${theme.palette.grey[80]};
    `;
}}
`;

const getAlertTypeCss = iconColor => css`
  color: ${darken(iconColor, 0.2)};

  &:hover {
    color: ${darken(iconColor, 0.3)};
  }
`;
const CloseIconButton = styled(Button)`
  border-width: 0;
  margin: 0;
  cursor: pointer;
  padding: 0;
  background-color: transparent;
  line-height: 1;
  margin-left: auto;
  ${({
  theme
}) => {
  return getAlertTypeCss(theme.palette.primary.main);
}};
`;

const _excluded$1 = ["type", "theme"];
const IconDiv = styled(Div).attrs(_ref => {
  let {
      type,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  const getColor = () => {
    if (type === 'success') {
      return theme.palette.success.main;
    }
    if (type === 'info') {
      return theme.palette.info.main;
    }
    if (type === 'warning') {
      return theme.palette.warning.main;
    }
    if (type === 'error') {
      return theme.palette.error.main;
    }
    return theme.palette.grey[100];
  };
  return _objectSpread2({
    pr: `${theme.spacing.sm}px`,
    lineHeight: '1px',
    color: getColor()
  }, props);
})``;

class Alert extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleClose", event => {
      var _this$props$onClose, _this$props;
      event.preventDefault();
      this.setState({
        closed: true
      });
      (_this$props$onClose = (_this$props = this.props).onClose) === null || _this$props$onClose === void 0 ? void 0 : _this$props$onClose.call(_this$props, event);
    });
  }
  UNSAFE_componentWillMount() {
    this.setState({
      closed: false
    });
  }
  render() {
    const {
      type,
      message,
      closable,
      icon,
      showIcon,
      props,
      styles
    } = this.props;
    let iconType = icon;
    if (!iconType) {
      switch (type) {
        case 'success':
          iconType = icons.CHECK_CIRCLE;
          break;
        case 'info':
          iconType = icons.INFO_CIRCLE;
          break;
        case 'error':
          iconType = icons.ERROR_CIRCLE;
          break;
        case 'warning':
          iconType = icons.WARNING;
          break;
        default:
          iconType = null;
      }
    }
    const closeButton = closable ? /*#__PURE__*/createElement(CloseIconButton, {
      onClick: this.handleClose
    }, /*#__PURE__*/createElement(Icon, {
      glyph: icons.CLOSE
    })) : null;
    return this.state.closed ? null : /*#__PURE__*/createElement(AlertDiv, _extends({
      type: type
    }, props === null || props === void 0 ? void 0 : props.root, styles === null || styles === void 0 ? void 0 : styles.root), showIcon && iconType ? /*#__PURE__*/createElement(IconDiv, _extends({}, styles === null || styles === void 0 ? void 0 : styles.iconContainer, {
      type: type
    }), /*#__PURE__*/createElement(Icon, _extends({
      size: 32,
      glyph: iconType
    }, props === null || props === void 0 ? void 0 : props.icon))) : null, message, closeButton);
  }
}
_defineProperty(Alert, "defaultProps", {
  showIcon: true,
  onClose: () => ({}),
  props: {},
  styles: {}
});

export default Alert;
